import { render } from "./Video.vue?vue&type=template&id=3e394afb&scoped=true"
import script from "./Video.vue?vue&type=script&setup=true&lang=js"
export * from "./Video.vue?vue&type=script&setup=true&lang=js"

import "./Video.vue?vue&type=style&index=0&id=3e394afb&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e394afb"],['__file',"src/components/Video.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e394afb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e394afb', __exports__)) {
    console.log('reload')
    api.reload('3e394afb', __exports__)
  }
  
  module.hot.accept("./Video.vue?vue&type=template&id=3e394afb&scoped=true", () => {
    console.log('re-render')
    api.rerender('3e394afb', render)
  })

}


export default __exports__